import { FullProject } from '../types';

export function isInvoiceRepriceActive(project: FullProject | undefined): boolean {
  return project?.repriceOrigin === 'INVOICE';
}
